import { useContext, useEffect, useRef, useState } from "react";
import { Button, Col, Form, message, Modal, Row, Select } from "antd";

import type { DraggableData, DraggableEvent } from "react-draggable";
import Draggable from "react-draggable";
import { useMutation, useQuery } from "@tanstack/react-query";
import { handleFetchUsers, handleImpersonateUser } from "../../../api/users";
import { AuthContext } from "../../../contexts/AuthContext";

export default function ImpersonateUser({ isVisible, setVisible }: any) {
    const { impersonateUser } = useContext(AuthContext);
    const [disabled, setDisabled] = useState(true);


    const [form] = Form.useForm();

    const draggleRef = useRef<HTMLDivElement>(null);
    const [bounds, setBounds] = useState({
        left: 0,
        top: 0,
        bottom: 0,
        right: 0,
    });

    const { data: users } = useQuery({
        queryKey: ["users", 1, 3000, `name=`],
        queryFn: () =>
            handleFetchUsers({
                page: 1,
                limit: 3000,
                params: `name=`,
            }),
    });

    const userOptions = users?.records?.map((user: any) => (
        <Select.Option key={user?._id} value={user?._id}>
            {`${user?.name} - ${user?.empId}`}
        </Select.Option>
    ));

    const onStart = (_event: DraggableEvent, uiData: DraggableData) => {
        const { clientWidth, clientHeight } = window.document.documentElement;
        const targetRect = draggleRef.current?.getBoundingClientRect();
        if (!targetRect) {
            return;
        }
        setBounds({
            left: -targetRect.left + uiData.x,
            right: clientWidth - (targetRect.right - uiData.x),
            top: -targetRect.top + uiData.y,
            bottom: clientHeight - (targetRect.bottom - uiData.y),
        });
    };

    const { mutate, isPending } = useMutation({
        mutationFn: handleImpersonateUser,
        onSuccess: (data) => {
            form.resetFields();
            setVisible(false);

            const credentials = {
                user: data?.user,
                token: data?.token,
            };
            impersonateUser(credentials);
        },
        onError: (error) => {
            message.error(`${error}`);
        },
    });

    const onSubmit = async () => {
        const { userId } = await form.validateFields();
        await mutate({ _id: userId });
    };
    const hideModal = () => {
        setVisible(false);
    };

    useEffect(() => {
        form.resetFields();
    }, []);

    return (
        <>
            <Modal
                title={
                    <div
                        style={{
                            width: "100%",
                            cursor: "move",
                        }}
                        onMouseOver={() => {
                            if (disabled) {
                                setDisabled(false);
                            }
                        }}
                        onMouseOut={() => {
                            setDisabled(true);
                        }}
                        onFocus={() => { }}
                        onBlur={() => { }}
                    >
                        Impersonate User
                    </div>
                }
                open={isVisible}
                onCancel={hideModal}
                modalRender={(modal) => (
                    <Draggable
                        disabled={disabled}
                        bounds={bounds}
                        nodeRef={draggleRef}
                        onStart={(event, uiData) => onStart(event, uiData)}
                    >
                        <div ref={draggleRef}>{modal}</div>
                    </Draggable>
                )}
                footer={[
                    <Button key="back" onClick={hideModal}>
                        Cancel
                    </Button>,
                    <Button
                        key="submit"
                        form="impersonateUser"
                        htmlType="submit"
                        type="primary"
                        onSubmit={onSubmit}
                        loading={isPending}
                    >
                        Impersonate
                    </Button>,
                ]}
            >
                <Form
                    layout={"vertical"}
                    form={form}
                    id="impersonateUser"
                    initialValues={{ layout: "vertical" }}
                    onFinish={onSubmit}
                >
                    <Row gutter={[16, 0]}>
                        <Col xs={{ span: 24 }} lg={{ span: 24 }}>
                            <Form.Item
                                name="userId"
                                rules={[{ required: false, message: "Please select user" }]}
                            >
                                <Select
                                    showSearch
                                    placeholder="Select User"
                                    filterOption={(input: any, option: any) =>
                                        (option?.children as string)
                                            .toLowerCase()
                                            .includes(input.toLowerCase())
                                    }
                                >
                                    {userOptions}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        </>
    );
}
